import { createRouter, createWebHistory } from 'vue-router';
// import store from './store'
// import commonFunction from "./composables/commonFunction"
// const { checkEmpty } = commonFunction()
const routes = [
  
  {
    path: "/",
    name: "Home",
    exact: true,
    component: () => import( "./pages/AccessCode.vue" ),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/accesscode',
    name: 'AccessCode',
    exact: true,
    component: () =>
      import('./pages/AccessCode.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    exact: true,
    component: () => import( "./pages/Dashboard.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users/add",
    name: "AddUser",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/users/AddUser.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/users/AddUser.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users/import",
    name: "BulkImport",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/users/BulkImport.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/users/BulkImport.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users/list",
    name: "ListUsers",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/users/ListUsers.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/users/ListUsers.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/users/permission",
    name: "PermissionSet",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/users/PermissionSet.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/users/PermissionSet.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/allcitizens",
    name: "AllCitizensList",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/citizen/AllCitizensList.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/citizen/AllCitizensList.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/minorcitizens",
    name: "MinorCitizens",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/citizen/MinorCitizens.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/citizen/MinorCitizens.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/nongoanresidents",
    name: "NonGoanResidents",
    component: () => import( "./pages/goa/citizen/NonGoanResidents.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/nonassameseresidents",
    name: "NonAssameseResidents",
    component: () => import( "./pages/assam/citizen/NonAssameseResidents.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/nonresidentgoans",
    name: "NonResidentGoans",
    component: () => import( "./pages/goa/citizen/NonResidentGoans.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/nonresidentassamese",
    name: "NonResidentAssamese",
    component: () => import( "./pages/assam/citizen/NonResidentAssamese.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/residentgoans",
    name: "ResidentGoans",
    component: () => import( "./pages/goa/citizen/ResidentGoans.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/residentassamese",
    name: "ResidentAssamese",
    component: () => import( "./pages/assam/citizen/ResidentAssamese.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/citizen/total-citizen",
    name: "CurrentGuests",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/demo/CurrentGuest.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/demo/CurrentGuest.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  
  {
    path: "/departments/agriculture",
    name: "Agriculture",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/Agriculture.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/Agriculture.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/education",
    name: "Education",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/Education.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/Education.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/excise",
    name: "Excise",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/Excise.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/Excise.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/finance",
    name: "Finance",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/Finance.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/Finance.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/forest",
    name: "Forest",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/Forest.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/Forest.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/handicraftsandtextile",
    name: "HandicraftsAndTextile",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/HandicraftsAndTextile.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/HandicraftsAndTextile.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/home",
    name: "Homedepartments",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/Home.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/Home.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/informationandpublicity",
    name: "InformationAndPublicity",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/InformationAndPublicity.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/InformationAndPublicity.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/informationtechnology",
    name: "InformationTechnology",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/InformationTechnology.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/InformationTechnology.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/departments/tourism",
    name: "Tourism",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Departments/Tourism.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Departments/Tourism.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/districts/northgoa",
    name: "NorthGoaDist",
    component: () => import( "./pages/goa/Districts/NorthGoaDist.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/districts/southgoa",
    name: "SouthGoaDist",
    component: () => import( "./pages/goa/Districts/SouthGoaDist.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/districts/underprogress",
    name: "AssamDist",
    component: () => import( "./pages/assam/Districts/BaksaDist.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/districts/karbianglong",
    name: "KarbiAnglongDist",
    component: () => import( "./pages/assam/Districts/KarbiAnglongDist.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/districts/sonitpur",
    name: "SonitpurDist",
    component: () => import( "./pages/assam/Districts/SonitpurDist.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/districts/dibrugarh",
    name: "DibrugarhDist",
    component: () => import( "./pages/assam/Districts/DibrugarhDist.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/districts/charaideo",
    name: "CharaideoDist",
    component: () => import( "./pages/assam/Districts/CharaideoDist.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/districts/baksa",
    name: "BaksaDist",
    component: () => import( "./pages/assam/Districts/BaksaDist.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/guwahatimunicipalcorporation",
    name: "GuwahatiMunicipalCouncil",
    component: () => import( "./pages/assam/LocalBodies/GuwahatiMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/mushalpurmunicipalboard",
    name: "MushalpurMunicipalCouncil",
    component: () => import( "./pages/assam/LocalBodies/MushalpurMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/dhemajimunicipalboard",
    name: "DhemajiMunicipalCouncil",
    component: () => import( "./pages/assam/LocalBodies/DhemajiMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/haflongmunicipalboard",
    name: "HaflongMunicipalCouncil",
    component: () => import( "./pages/assam/LocalBodies/HaflongMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/goalparamunicipalboard",
    name: "GoalparaMunicipalCouncil",
    component: () => import( "./pages/assam/LocalBodies/GoalparaMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/bicholimmunicipalcouncil",
    name: "BicholimMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/BicholimMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  
  {
    path: "/localbodies/canaconamunicipalcouncil",
    name: "CanaconaMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/CanaconaMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/corporationcitypanaji",
    name: "CorporationCityPanaji",
    component: () => import( "./pages/goa/LocalBodies/CorporationCityPanaji.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/cuncolimmunicipalcouncil",
    name: "CuncolimMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/CuncolimMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/mapusamunicipalcouncil",
    name: "MapusaMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/MapusaMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/margaomunicipalcouncil",
    name: "MargaoMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/MargaoMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/mormugaomunicipalcouncil",
    name: "MormugaoMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/MormugaoMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/pernemmunicipalcouncil",
    name: "PernemMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/PernemMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/pondamunicipalcouncil",
    name: "PondaMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/PondaMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/quepemmunicipalcouncil",
    name: "QuepemMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/QuepemMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/localbodies/valpoimunicipalcouncil",
    name: "ValpoiMunicipalCouncil",
    component: () => import( "./pages/goa/LocalBodies/ValpoiMunicipalCouncil.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/supportticket/closed",
    name: "ClosedSupportTickets",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SupportTicket/ClosedSupportTickets.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SupportTicket/ClosedSupportTickets.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/supportticket/open",
    name: "OpenSupportTickets",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SupportTicket/OpenSupportTickets.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SupportTicket/OpenSupportTickets.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schemes/discontinued",
    name: "DiscontinuedSchemes",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Schemes/DiscontinuedSchemes.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Schemes/DiscontinuedSchemes.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schemes/listing",
    name: "SchemesList",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Schemes/SchemesList.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Schemes/SchemesList.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schemes/totalbeneficaries",
    name: "TotalBeneficaries",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Schemes/TotalBeneficaries.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Schemes/TotalBeneficaries.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/announcements/new",
    name: "NewAnnouncement",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Announcements/NewAnnouncement.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Announcements/NewAnnouncement.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/announcements/previous",
    name: "PreviousAnnouncements",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Announcements/PreviousAnnouncements.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Announcements/PreviousAnnouncements.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/polls/new",
    name: "NewPoll",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Polls/NewPoll.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Polls/NewPoll.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/polls/conducted",
    name: "PollsConducted",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Polls/PollsConducted.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Polls/PollsConducted.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/accountstatement",
    name: "AccountStatement",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Billing/AccountStatement.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Billing/AccountStatement.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/dashboard",
    name: "BillingDashboard",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Billing/Dashboard.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Billing/Dashboard.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/paymentreceipts",
    name: "PaymentReceipts",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Billing/PaymentReceipts.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Billing/PaymentReceipts.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/billing/taxinvoices",
    name: "TaxInvoices",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/Billing/TaxInvoices.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/Billing/TaxInvoices.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cloudtelephoney/CustomTunes",
    name: "CostumTunes",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/CloudTelephoney/CostumTunes.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/CloudTelephoney/CostumTunes.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cloudtelephoney/virtualnumbers",
    name: "VirtualNumbers",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/CloudTelephoney/VirtualNumbers.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/CloudTelephoney/VirtualNumbers.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/aadharlogs",
    name: "AadharLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/AadharLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/AadharLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/bharatmessengerlogs",
    name: "BharatMessengerLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/BharatMessengerLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/BharatMessengerLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/drivinglicencelogs",
    name: "DLLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/DLLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/DLLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/emaillogs",
    name: "EmailLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/EmailLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/EmailLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/incomingcalllogs",
    name: "IncomingCallLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/IncomingCallLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/IncomingCallLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/outgoingcalllogs",
    name: "OutgoingCallLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/OutgoingCallLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/OutgoingCallLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/panlogs",
    name: "PANLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/PANLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/PANLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/passportlogs",
    name: "PassportLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/PassportLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/PassportLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/smslogs",
    name: "SMSLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/SMSLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/SMSLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemlogs/webbotlogs",
    name: "WebBotLogs",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemLogs/WebBotLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemLogs/WebBotLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemsettings/apisettings",
    name: "APISettings",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemSettings/APISettings.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemSettings/APISettings.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/systemsettings/citizentags",
    name: "CitizenTags",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/SystemSettings/CitizenTags.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/SystemSettings/CitizenTags.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/guests/reports",
    name: "GuestsReport",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/demo/GuestsReport.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/demo/GuestsReport.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/branchlist",
    name: "BranchList",
    component: () => import( "./pages/BranchList.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/chatbot',
    name: 'ChatBotLandingPage',
    exact: true,
    component: () =>
      import('./pages/chatbot.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/webbot/:param1',
    name: 'WebBot',
    exact: true,
    component: () =>
      import('./pages/WebBot.vue'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: "/campaign",
    name: "CampaignList",
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/campaign/CampaignList.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/campaign/CampaignList.vue" );
      } else {
        return import( "./pages/assam/campaign/CampaignList.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/campaign/pushlogs/:campaignId?',
    name: 'PushCampaignLogs',
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/campaign/PushCampaignLogs.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/campaign/PushCampaignLogs.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/campaigntemplate/pushnotification',
    name: 'PushNotificationCampaignListing',
    component: () => {
      if ( localStorage.clienttype == 2 ) {
        return import( "./pages/goa/campaigntemplatelist/PushNotificationCampaignListing.vue" );
      } else if ( localStorage.clienttype == 3 ) {
        return import( "./pages/assam/campaigntemplatelist/PushNotificationCampaignListing.vue" );
      }
    },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/underprogress",
    name: "underprogress",
    exact: true,
    component: () => import( "./pages/UnderProgress.vue" ),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/:pathMatch(.*)",
    name: "notfound",
    component: () => import( "./pages/NotFound" ),
    meta: {
      requiresAuth: false,
    },
  },

];

const router = createRouter( {
  history: createWebHistory( process.env.BASE_URL ),
  routes,
} );
router.beforeEach( async ( to, from, next ) => {
  const authenticatedUser = localStorage.user_reference;
  const requiresAuth = to.matched.some( ( record ) => record.meta.requiresAuth );
  const checkModuleAccess = to.matched.some( ( record ) => record.meta.checkModuleAccess );
  const moduleId = to.meta.moduleId;
  const permission_fks = [ 1, 11, 12 ];

  if (requiresAuth && !authenticatedUser) {
    next( "/" );
  } else {
    if ( checkModuleAccess ) {
      if ( permission_fks.includes( moduleId ) ) {
        next();
      } else {
        next( false );
      }
    } else {
      next();
    }
  }
} );

export default router;